import NewStaticTable from 'components/staticTable/NewStaticTable'
import Modal from 'global/Modal/Modal'
import SimpleButton from 'global/SimpleButton/SimpleButton'
import { useEffect, useState } from 'react'
import { getAPI } from 'services/CRUDServices'
import { ConsumeColumns } from './column'
import SinglePayment from '../single-payment'
import { usePayment } from '../single-payment/usepayment'
import { getDay, getPrice } from 'tools/functions/Methods'
import { addEditUrls } from 'services/api.enums'
import { FinancialCalculation } from './type'
import SharePercentFooter from '../components/sahred-percent'
import { ExportExcel } from 'tools/functions/ExportMyExcel'

type ConsumerCreditProps = {
  open: boolean
  setOpen: (val: any) => void
  currentData: any
}

function ConsumerCredit({ open, setOpen, currentData }: ConsumerCreditProps) {

  const { handleSubmit, refId } = usePayment()
  const [tableData, setTabledata] = useState<any[]>([])
  const [sharePercentInfo, setSharePercentInfo] =
    useState<FinancialCalculation>()

  useEffect(() => {
    if (!open) return

    getAPI(
      `/customer-api/subsidiaryLedger/findByCredit/${currentData.id}`
    ).then((res) => {
      const data = res.data.payload.map((item) => ({
        ...item,
        createDateTime: getDay(item.createDateTime),
        amount:getPrice(item.amount)
      }))
      setTabledata(data)
    })

    getAPI(addEditUrls.fetchSharePercentageFromCredit + currentData.id).then(
      (res) => {
        setSharePercentInfo({
          ...res.data.payload,
          usedCredit: currentData.findAllByConsignmentPriceFromHub.useCredit,
        })
      }
    )
  }, [open, currentData.id])

  function exportExcel() {
    console.log(tableData)
    ExportExcel({
      data: tableData,
      columns: ConsumeColumns,
    })
  }

  return (
    <>
      <Modal
        visible={open}
        setVisible={setOpen}
        title='جزئیات اعتبار مصرفی'
        className='w-[30rem]'
      >
        <div className='mb-4'>
          <span>هاب: </span>
          <span className='font-semibold'>
            {currentData.creditRecipientHub?.name}
          </span>
        </div>
        {/* <button onClick={exportExcel}>خروجی اکسل</button> */}
        <NewStaticTable
          maxHeight='35rem'
          data={tableData}
          THWrapper='whitespace-nowrap'
          column={ConsumeColumns}
          footer={
            <SharePercentFooter
              sharePercentInfo={sharePercentInfo}
              columnLength={ConsumeColumns.length}
            />
          }
        />

        <div className='btnForm mt-4 flex gap-2 justify-end'>
          <SimpleButton
            handelClick={() => setOpen({ ...open, inquirtAccount: false })}
            text='انصراف'
            className='text-tomato'
          />
          <SimpleButton
            type='submit'
            text='تایید و واریز'
            className='full-tomato-btn'
            disabled={tableData.length === 0}
            handelClick={() =>
              handleSubmit({
                ...currentData,
                pay: sharePercentInfo?.totalPayable,
              })
            }
          />
        </div>
      </Modal>

      <SinglePayment refId={refId} />
    </>
  )
}

export default ConsumerCredit
